import { render, staticRenderFns } from "./EmailVerificationForm.vue?vue&type=template&id=16e5991d&scoped=true"
import script from "./EmailVerificationForm.vue?vue&type=script&lang=js"
export * from "./EmailVerificationForm.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationForm.vue?vue&type=style&index=0&id=16e5991d&prod&lang=scss"
import style1 from "./EmailVerificationForm.vue?vue&type=style&index=1&id=16e5991d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e5991d",
  null
  
)

export default component.exports